import React from "react";
import styled from "styled-components";
import CardanoLogo from "../public/cardano.svg";
import ErgoLogo from "../public/ergo.svg";
import NervosLogo from "../public/nervos-black.svg";

import "./App.css";

const Header = styled.div`
  display: grid;
  height: 30vh;
  background-color: #5495cf;
  grid-template-rows: 2fr 1fr 2fr;
  border-bottom: 2px solid grey;
`;

const Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${({ sub }) => (sub ? "1.8rem" : "2.5rem")};
  font-family: Montserrat;
  color: dark-blue;
  margin: ${({ sub }) => (sub ? "1.5rem 0" : "initial")};
`;

const Description = styled.h3`
  font-family: Sarabun;
  margin: 0 !important;
  color: dark-blue;
  font-weight: 300;
`;

const Icons = styled.div`
  background: white;
  border-radius: 64px;
  height: 55%;
  box-shadow: 1px 2px 3px grey;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2rem;
  min-width: 200px;
  max-width: 200px;
  max-height: 64px;
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FlexLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Body = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-color: #eceeef;
  border: 1px solid #929a9c;
  box shadow 1px 2px 3px #c9d0d2;
  margin: 1rem 1rem;
  padding: 1rem;
  height: 100%
`;

function App() {
  return (
    <div className="App">
      <Header>
        <Title>EUTXO Stake Pool</Title>
        <FlexContainer>
          <Description>
            A grassroots initiative to drive innovation across eUTxO blockchains
          </Description>
        </FlexContainer>
        <FlexContainer>
          <Icons>
          <FlexLink href="https://cardano.org/" target="_blank">
            <object
              type="image/svg+xml"
              aria-label="logo"
              data={CardanoLogo}
              alt="ad3e877815c318360ac97b6605ea71b089bca239a843d2f455b599fe74e0d581"
              height="40px"
              width="40px"
              style={{pointerEvents: 'none'}}
            />
          </FlexLink>
          <FlexLink href="https://ergoplatform.org/" target="_blank">
            <object
              type="image/svg+xml"
              aria-label="logo"
              data={ErgoLogo}
              alt="2ab64afd2384a9d2f25d429df6d0108df556bc4b9fe7f98267aaa737e6a2ed58"
              height="40px"
              width="40px"
              style={{pointerEvents: 'none'}}
            />
          </FlexLink>
          <FlexLink href="https://www.nervos.org/" target={"_blank"}>
            <object
              type="image/svg+xml"
              aria-label="logo"
              data={NervosLogo}
              alt="5dd2cd846e1fd42c084d9d9c4eb85821802e8cccdb5b2683d5613e2ad026ad9b"
              height="40px"
              width="40px"
              style={{pointerEvents: 'none'}}
            />
          </FlexLink>
          </Icons>
        </FlexContainer>
      </Header>
      <Body>
        <Title sub>What is the purpose of this pool?</Title>
        <Description>
          We are using pool rewards to put out bounties for programming problems
          that one eUTxO chain solved but the others did not.
        </Description>
        <br />
        <Description>
          Let's say you see a cool feature on Minswap that you would like to see
          implemented on Ergodex but have no idea who you should propose it to.
          This is where we can help you and the ecosystem.
        </Description>
        <Title sub>Sounds good, how do I do this?</Title>
        <Description>
          To delegate, simply go to your favorite wallet (we recommend Eternl or
          Nami), go to Staking, look for the <b>EUTXO</b> ticker, delegate and
          done! You have nothing else to do to claim your staking rewards.
        </Description>
        <br />
        <Description>
          On Cardano when you delegate you are not exposing your funds to any
          risk at all, you are only "voting" with a snapshot of your wallet's
          content roughly every five days. Your funds never leave your wallet
          and you are free to spend them any way you see fit at any time without
          having to unstake them, so this is a no risk-activity.
        </Description>
        <br />
        <Description>
          A good way to visualize this concept is to imagine you have a lapel
          pin that says <b>"I voted for EUTXO"</b> and the whole world
          recognizes your vote just by reading your lapel pin.
        </Description>
        <br />
        <Description>
          To propose a bounty, you will need to connect to us on{" "}
          <a href="https://twitter.com/stuffedkohlrabi" target="_blank">
            Twitter
          </a>{" "}
          or Discord.
          <br />
          Our Discord server is being set up as you are reading this. You will
          be able to propose a problem, we will channel it to the relevant
          programmers in the community and then establish a bounty in ADA.
        </Description>
        <br />
        <Description>
          Once development is ready, the community either approves or rejects
          the solution and if it was accepted, the bounty is paid out.
        </Description>
        <Title sub>What are the fees?</Title>
        <Description>
          The pool operates on ₳340 fixed fee and 3.5% of the total rewards.
          <br />
          <br />
          What does this mean?
          <br />
          <br />
        </Description>
        <Description>
          A fee of ₳340 will be assigned to the pool for every epoch that the
          pool finds a block. This is a compulsory feature of the system and it
          guarantees the bare minimum of operational expenses being covered.
          This is a cost that all delegators share and divide but only if a
          block is found by the pool. You will{" "}
          <b>under no circumstance be forced</b> to pay any fee out of pocket,
          individually.
        </Description>
        <br />
        <Description>
          Beyond this fee the pool takes 3.5% of the rewards. This amount will
          be used to fund the bounty program in its entirety. When we have
          enough delegation to consistently mint blocks in each epoch, 0.5% of
          the rewards will be allocated to cover for pool and organization costs
          and the remaining 3% will still be funneled into the pool's bounty
          fund.
        </Description>
        <br />
        <Title sub>
          But I have seen big pools with 0% fees, why can't you do that too?
        </Title>
        <Description>
          As this is a utility pool that finances innovation we cannot afford to
          operate on low fees, otherwise we could never reward the developers'
          work.
        </Description>
        <Description>
          We also don't want to get into a situation where we cannot sustain our
          mission. Look at it this way - when compared to a pool that takes 1%
          rewards, instead of earning 99%, now you will earn 96.5% of all your
          possible rewards and with your tiny sacrifice you are kickstarting
          innovation on your favorite blockchains :)
        </Description>

        <Title sub>Who operates EUTXO?</Title>
        <Description>
          I am Attila Veres, a software developer living in Vienna. I have been
          active in the Cardano and Ergo communities with different projects
          ranging from miner to community manager. I have been an enthusiastic
          fan of the underlying technology, namely the extended Unspent
          Transaction Output model (eUTxO).
        </Description>
      </Body>
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js